<template>
    <div>
        <div class="form-group">
            <label>Endpoint</label>
            <input type="text" class="form-control" v-model="data.endpoint">
        </div>
        <div class="form-group">
            <label>Public Key</label>
            <input type="text" class="form-control" v-model="data.publicKey">
        </div>
        <div class="form-group">
            <label>Private Key</label>
            <input type="text" class="form-control" v-model="data.privateKey">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
